<template>
  <EditPopup
    title="线索区识别"
    class="shoot-data-view-clue-detection"
    :controls="controls"
    @mousewheel.stop
    @click.stop
  >
    <div class="shoot-data-view-clue-detection-container"
      :style="{
        width: '26.25rem',
      }"
    >
      <LeafletConstructor
        :isAddBaseLayer="true"
        :style="{
          height: '15rem',
        }"
        @mapInit="mapInit"
      ></LeafletConstructor>
      <TableCom
        :tableList="list"
        :tableProps="tableProps"
        height="15rem"
        row-key="index"
        @select="checkSelect"
        @select-all="checkSelectAll"
        :checkbox="true"
        :cell-style="cellStyle"
        ref="tableRef"
      ></TableCom>
      
      <div class="control">
        <ButtonList 
          :list="buttonList"
          :target="buttonTarget"
        />
      </div>
    </div>
  </EditPopup>
</template>

<script setup>
import { 
  onBeforeMount, onMounted, onUnmounted, onUpdated,
  computed, watch, ref, nextTick, reactive, markRaw,
  h, defineComponent, toRaw,
} from 'vue';
import store from '@/store';
import { isNull, dayjs, message, vueCreateAppInit } from '@/utils/js/initVariable';
import { jsonStyleInit } from '@/utils/js/leaflet';

import EditPopup from '@/views/Home/component/ManagePanel/components/WorkSpace/components/WorkSpaceData/components/CustomLocaleControl/components/EditPopup';
import LeafletConstructor from '@/components/LeafletConstructor';
import TableCom from '@/components/TableCom';
import ButtonList from '@/components/ButtonList';

import { addPolygonClueArea } from '@/api/Region';

// props
const props = defineProps({
  list: { type: Array, },
  updateList: { type: Array, },
});
// emit
const emit = defineEmits([
  'close',
]);

// 组件挂载前
onBeforeMount(()=>{

});
// 组件挂载后
onMounted(()=>{
  
});
// 组件更新后
onUpdated(()=>{

});
// 组件销毁后
onUnmounted(()=>{

});

const controls = ref([
  { iconName: 'close-box', fill: 'rgb(6, 180, 221)', onClick: ()=>{ emit('close') }, },
])

let layerGroup,
    layerGroupClear = ()=>{
      layerGroup && layerGroup.clearLayers();
    },
    layerGroupFitBounds = ()=>{
      if(!layerGroup)return;
      const bounds = layerGroup.getBounds();
      bounds.isValid() && map && map.fitBounds(bounds);
    }

let map,
mapInit = (m)=>{
  map = m;
  layerGroup = L.featureGroup().addTo(map);
  init();
}

const tableProps = ref([
  { label: '优先级', prop: 'priority', },
  { label: '区域类型', prop: 'polygonTypeShowName', },
  { label: '数据时间', prop: 'scanProductTime', },
])

const layerInner = (layer)=>{
  layer && layerGroup && layerGroup.addLayer(layer);
},
layerRemove = (layer)=>{
  layer && layerGroup && layerGroup.removeLayer(layer);
}

const checkSelect = (selection, row)=>{
  const layer = row['layer'];
  if(selection.includes(row)){
    layerInner(layer);
  }else{
    layerRemove(layer);
  }
}

const checkSelectAll = (selection)=>{
  // console.log(selection);
  if(selection.length == 0){
    layerGroupClear();
  }else{
    selection.forEach(item=>{
      const layer = item['layer'];
      layerInner(layer);
    })
  }
}

const cellStyle = ({ row, column })=>{
  // console.log(row, column);
  if(column['property'] != 'polygonTypeShowName'){
    return
  }
  let color;
  if(fillIds.includes(row['polygonTypeShowId'])){
    color = importFill;
  }else if(defaultFillIds.includes(row['polygonTypeShowId'])){
    color = undefined;
  }else if(row['polygonTypeShowId']){
    color = normalFill;
  }
  return {
    color,
  }
}

const tableRef = ref(), tref = computed(()=> tableRef.value['thatRef'])
const fillIds = [ 3, 4, 8 ], defaultFillIds = [ 5 ], normalFill = 'rgb(242, 186, 44)', importFill = 'rgb(206 28 13)';
const init = ()=>{
  // const latlng = L.latLng({ lat: '32.501944', lng: '-93.662778' }),
  //       bounds = latlng.toBounds(5 * 1000);

  // L.imageOverlay(
  //   'https://file.mizarvision.com/open/2064_2026-01_heatmap_dd18d93d.png',
  //   bounds
  // ).addTo(layerGroup);
  // layerGroupFitBounds();
  // return
  const ref = tref.value;
  (props.list || []).forEach((item, index)=>{
    let fill;
    if(fillIds.includes(item['polygonTypeShowId'])){
      fill = importFill;
    }else if(item['polygonTypeShowId']){
      fill = normalFill;
    }
    const json = JSON.parse(item['scanSatellitePolygon']);
    // 处理区域样式
    jsonStyleInit(json, { fill, });
    let layer;
    L.geoJSON(json, {
      onEachFeature: (feature, l)=>{
        layer = l;
      },
    });
    layer.addTo(layerGroup);
    item['layer'] = layer;
    item['index'] = index;
    ref && ref['toggleRowSelection'] && ref['toggleRowSelection'](item, true);
  })
  layerGroupFitBounds();
}

const submitFn = (target, btn, loadFn)=>{
  // console.log(target, btn, loadFn);
  const selection = tref.value['getSelectionRows'] && tref.value['getSelectionRows']();
  console.log(selection);
  if(!(selection && selection.length > 0)){
    message('请勾选线索区', 2);
    return;
  }
  addPolygonClueArea({
    polygonList: selection.map(item=>{
      return {
        ...item,
        layer: undefined,
      }
    }),
    updateList: props.updateList,
  }).then(res=>{
    if(res.data.code == 1004){
      message(res.data.msg, 1);
      emit('close');
    }
  }).catch(err=>{
    console.log(err);
  }).finally(()=>{
    loadFn && loadFn();
  });
}

const buttonTarget = ref({});
const buttonList = ref([
  // { name: '查询', icon: 'el-Search', type: 'primary', fun: searchFun },
  { name: '确认', type: 'primary', fun: submitFn },
])

</script>

<style lang='less'>
.shoot-data-view-clue-detection-container{
  .el-table{
    .el-table__cell{
      text-align: center;  
    }
  }
}
</style>

<style lang='less' scoped>
.shoot-data-view-clue-detection-container{
  display: flex;
  flex-direction: column;
  gap: 10px;
  .control{
    text-align:right;
  }
}

</style>